<template>
  <div>
    <div
      class="wrap-tooltip"
      @mouseleave="isShowPopup = false"
    >
      <!-- Icon -->
      <img
        :src="require('@/assets/icon/help.png')"
        alt="type-help"
        @click="isShowPopup = true"
        @mouseover="isShowPopup = true"
      >

      <!-- Tooltip Popup -->
      <div
        v-if="isShowPopup"
        class="tooltip-popup"
      >
        <p class="description">{{ description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable max-len, no-console, no-unused-vars */
export default {
  props: {
    description: {
      type: String,
      default: () => '',
    },
  },

  data() {
    return {
      isShowPopup: false,
    };
  },
};
</script>

<style lang="scss" scoped>
  .wrap-tooltip {
    position: relative;

    img {
      width: 9px;
      height: auto;
    }

    .tooltip-popup {
      width: max-content;
      min-width: 134px;
      max-width: 300px;
      position: absolute;
      top: 20px;
      left: 0;
      background-color: white;
      padding: 8px;
      border-radius: 8px;
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
      z-index: 3;

      p {
        font-size: 12px;
        color: $black-sample;
        line-height: 12px;
        margin-bottom: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tooltip/jTooltipHint.vue